import { NunaKeyLandingPage } from 'pages/NunaKeyLanding.page'
import './App.css'
import { createTheme, ThemeProvider } from '@mui/material'

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 790,
      lg: 1400,
      xl: 1535,
    },
  },
})

function App() {
  return (
    <ThemeProvider theme={theme}>
      <NunaKeyLandingPage />
    </ThemeProvider>
  )
}

export default App
